module.exports = __webpack_public_path__ + "assets/img/00057.404c5416.png";